var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmLeads = function SvgBmLeads(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;}.a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-411 -576)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18,
    height: 18,
    transform: "translate(411 576)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(309 485)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.316,
    cy: 3.316,
    r: 3.316,
    transform: "translate(105.316 93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M111.474,110.74v-1.83c-.04-.017-.079-.036-.119-.052a.547.547,0,0,0-.7.266l-1.261,2.62a.85.85,0,0,1-1.532,0l-1.261-2.62a.547.547,0,0,0-.7-.266A6.156,6.156,0,0,0,102,114.589h12.634l-2.676-2.675A1.626,1.626,0,0,1,111.474,110.74Z",
    transform: "translate(0 -8.326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M131.371,108.346l-3.138-3.138a.684.684,0,0,0-.5-.207h-3.02a.708.708,0,0,0-.711.711v3.02a.687.687,0,0,0,.207.5l3.138,3.138a.715.715,0,0,0,1.007,0l3.02-3.02a.714.714,0,0,0,0-1.007Zm-4.737-.711a.714.714,0,1,1,.207-.5A.685.685,0,0,1,126.635,107.635Z",
    transform: "translate(-11.579 -6.316)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmLeads, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_Leads.c29f925d.svg";
export { ForwardRef as ReactComponent };